import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";


export default function Layout() {
  const [open, setOpen] = useState(true);

  // Auto collapse on mobile + auto expand on desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOpen(false); // hide on mobile
      } else {
        setOpen(true); // show on desktop
      }
    };

    handleResize(); // run on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [todayTotal, setTodayTotal] = useState(0);
  const fetchTodayTotal = async () => {
    try {
      const res = await fetch("https://matrimony.cubixsystems.com/api/today_total.php");
      const data = await res.json();

      if (data.status) {
        setTodayTotal(data.total || 0);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchTodayTotal();

    // 🔁 Auto refresh every 5 seconds
    const interval = setInterval(() => {
      fetchTodayTotal();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container-fluid p-0">

      <div
        className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
        style={{
          zIndex: 999,
          cursor: "pointer",
          position: "fixed",
          left: open ? "350px" : "60px",
          top: "0",
          transition: "left 0.3s ease"
        }}
        onClick={() => setOpen(!open)}
      >
        <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
          ☰
        </span>
      </div>




      <div className="d-flex" style={{ height: "100vh" }}>

        {/* LEFT SIDEBAR */}
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease",

          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddiingLeft: '30px'
          }}
        >
          <div>
            <TopBanner />
          </div>
          <div className="area">
            <div className="row">
              <div className="col-md-2 col-6">
                <Link to="../ManageStudent">
                <div className="dashbox">
                  {/* <img src="./images/rupee.png" alt="" style={{ height: '60%' }} /> */}
                  <div>
                    <i class="fa fa-address-book-o" aria-hidden="true" style={{ fontSize: '30pt', marginBottom: '10px', color: 'orange' }}></i>
                    <h2 className="dashtitle">Manage Students</h2>
                    {/* <h2 className="dashamount">₹ {todayTotal}</h2> */}
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-md-2 col-6">
                <Link to="../Visiting">
                <div className="dashbox">
                  {/* <img src="./images/rupee.png" alt="" style={{ height: '60%' }} /> */}
                  <div>
                    <i class="fa fa-rupee" aria-hidden="true" style={{ fontSize: '30pt', marginBottom: '10px', color: 'orange' }}></i>
                    <h2 className="dashtitle">Fee Collection</h2>
                    {/* <h2 className="dashamount">₹ {todayTotal}</h2> */}
                  </div>
                </div>
                </Link>
              </div>
              <div className="col-md-2 col-6">
                <Link to="#">
                <div className="dashbox">
                  {/* <img src="./images/rupee.png" alt="" style={{ height: '60%' }} /> */}
                  <div>
                    <i class="fa fa-rupee" aria-hidden="true" style={{ fontSize: '30pt', marginBottom: '10px', color: 'orange' }}></i>
                    <h2 className="dashtitle">Pending Fee Info</h2>
                    {/* <h2 className="dashamount">₹ {todayTotal}</h2> */}
                  </div>
                </div>
                </Link>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
}
